import { Accordion } from '@risksmart-app/atomic-ui';
import type { ReactNode } from 'react';

import ConditionalSection from './ConditionalSection';
import type { SectionConfig } from './hooks/useSectionManager';

interface Props {
  section: SectionConfig;
  children: ReactNode;
}

export const DraggableSection = ({ section, children }: Props) => {
  return (
    <ConditionalSection sectionId={section.SectionId}>
      <Accordion.Item value={section.SectionId}>
        <Accordion.Header>
          <Accordion.Trigger>{section.Label}</Accordion.Trigger>
        </Accordion.Header>
        <Accordion.Content>
          <div>{children}</div>
        </Accordion.Content>
      </Accordion.Item>
    </ConditionalSection>
  );
};
